import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CompanyServices } from '../../common/models/user.models';
import ServiceCard from '../services/ServiceCard';
import { getSortedServiceConfigurationsByStatus } from '../services/services.utils';

export interface CompanyServicesProps {
  services: CompanyServices;
}

export default function CompanyServicesInfo({ services }: CompanyServicesProps): React.JSX.Element {
  const { t } = useTranslation(['company']);

  const [enabledServiceConfigurations, disabledServiceConfigurations] = getSortedServiceConfigurationsByStatus(services);
  const sortedServices = enabledServiceConfigurations.concat(disabledServiceConfigurations);

  return (
    <Box sx={{ width: { md: 600 } }}>
      <Typography variant="titleMedium" sx={{ mb: 1.5 }}>
        {t('company:services_to_buyers')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {sortedServices.map((configuration) => (
          <ServiceCard
            key={configuration.service}
            configuration={configuration}
            companyServices={services}
            readOnly
          />
        ))}
      </Box>
    </Box>
  );
}
